import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'SO No',
     label: 'SO No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     locked: true,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'soDate',
     field: FIELDS.SODATE,
     title: 'SO Date',
     label: 'SO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFirstName',
     field: FIELDS.CONTACT_FIRST_NAME,
     title: 'Contact First Name',
     label: 'Contact First Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactLastName',
     field: FIELDS.CONTACT_LAST_NAME,
     title: 'Contact Last Name',
     label: 'Contact Last Name',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'billingAddress',
     field: FIELDS.BILLING_ADDRESS,
     title: 'Billing Address',
     label: 'Billing Address',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingAddress',
     field: FIELDS.SHIPPING_ADDRESS,
     title: 'Shipping Address',
     label: 'Shipping Address',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'billingTermName',
     field: FIELDS.BILLING_TERM_NAME,
     title: 'Billing Terms',
     label: 'Billing Terms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isAuthorized',
     field: FIELDS.IS_AUTHORIZED,
     title: 'Authorized',
     label: 'Authorized',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'SubTotal',
     label: 'SubTotal',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'proformaAmountPaid',
     field: FIELDS.PROFORMA_AMOUNT_PAID,
     title: 'Proforma Amount Paid',
     label: 'Proforma Amount Paid',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateProformaPaid',
     field: FIELDS.DATE_PROFORMA_PAID,
     title: 'Date Proforma Paid',
     label: 'Date Proforma Paid',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'estimatedProfit',
     field: FIELDS.ESTIMATED_PROFIT,
     title: 'Est. Profit',
     label: 'Est. Profit',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'estimatedMargin',
     field: FIELDS.ESTIMATED_MARGIN,
     title: 'Est. Margin',
     label: 'Est. Margin',
     cell: 'formatPercentage',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'actualProfit',
     field: FIELDS.ACTUAL_PROFIT,
     title: 'Actual Profit',
     label: 'Actual Profit',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'actualMargin',
     field: FIELDS.ACTUAL_MARGIN,
     title: 'Actual Margin',
     label: 'Actual Margin',
     cell: 'formatPercentage',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'customerPo',
     field: FIELDS.CUSTOMER_PO,
     title: 'Customer PO',
     label: 'Customer PO',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Authorized',
     label: 'Date Authorized',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isBillingTermPrePay',
     field: FIELDS.IS_BILLING_TERM_PRE_PAY,
     title: 'Proforma',
     label: 'Proforma',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'incoTypeName',
     field: FIELDS.INCO_TYPE_NAME,
     title: 'IncoTerms',
     label: 'IncoTerms',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shipOnCompanyAccount',
     field: FIELDS.SHIP_ON_COMPANY_ACCOUNT,
     title: 'Ship On Company Acct',
     label: 'Ship On Company Acct',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingAccountNumber',
     field: FIELDS.SHIPPING_ACCOUNT_NUMBER,
     title: 'Ship Acct. No.',
     label: 'Ship Acct. No.',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesTypeName',
     field: FIELDS.SALES_TYPE_NAME,
     title: 'Sales Type',
     label: 'Sales Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalQuantity',
     field: FIELDS.TOTAL_QUANTITY,
     title: 'Total Qty',
     label: 'Total Qty',
     cell: 'formatSeparator',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCost',
     field: FIELDS.TOTAL_COST,
     title: 'Total Cost',
     label: 'Total Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalPrice',
     field: FIELDS.TOTAL_PRICE,
     title: 'Total Price',
     label: 'Total Price',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'active',
     field: FIELDS.ACTIVE,
     title: 'Active',
     label: 'Active',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'attention',
     field: FIELDS.ATTENTION,
     title: 'Attention',
     label: 'Attention',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'internalComments',
     field: FIELDS.INTERNAL_COMMENTS,
     title: 'Internal Comments',
     label: 'Internal Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency Type',
     label: 'Currency Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch Rate',
     label: 'Exch Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Tax',
     label: 'Total Charges Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non Tax',
     label: 'Total Charges Non Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingCharges',
     field: FIELDS.SHIPPING_CHARGES,
     title: 'Shipping Charges',
     label: 'Shipping Charges',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Subtotal Conv.',
     label: 'Subtotal Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Conv.',
     label: 'Total Line Cost Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Tax Conv.',
     label: 'Total Charges Tax Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Tax Conv.',
     label: 'Total Charges Non Tax Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Conv.',
     label: 'Total Charges Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Conv.',
     label: 'Total Charges Cost Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Conv.',
     label: 'Total Conv.',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isProformaPaid',
     field: FIELDS.IS_PROFORMA_PAID,
     title: 'Proforma Paid',
     label: 'Proforma Paid',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateProformaSent',
     field: FIELDS.DATE_PROFORMA_SENT,
     title: 'Date Proforma Sent',
     label: 'Date Proforma Sent',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'alwaysShipBy',
     field: FIELDS.ALWAYS_SHIP_BY,
     title: 'Always Ship By',
     label: 'Always Ship By',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'Tracking No.',
     label: 'Tracking No.',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateEmailed',
     field: FIELDS.DATE_EMAILED,
     title: 'Date Emailed',
     label: 'Date Emailed',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
